import { types, Instance } from 'mobx-state-tree';
import { AddressAutocompleteModel } from '../sub-stores/AddressAutocomplete';
import { AddressVerificationModel } from '../sub-stores/AddressVerification';

const AddressValidation = types
  .model({
    addressVerification: types.optional(AddressVerificationModel, {}),
    addressAutocomplete: types.optional(AddressAutocompleteModel, {}),
  })
  .actions(self => {
    const setIsEnabled = (isEnabled = true): void => {
      self.addressAutocomplete.setIsEnabled(isEnabled);
      self.addressVerification.setIsEnabled(isEnabled);
    };

    return {
      setIsEnabled,
    };
  });

export interface IAddressValidation
  extends Instance<typeof AddressValidation> {}

export default AddressValidation;
